import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { selectUserId, selectWork, selectWorks } from '../../../../Api/selectors';
import styled from 'styled-components';
import {
  INTERIOR_PREVIEW_VALUES,
  EXTERIOR_PREVIEW_VALUES,
  REQUEST_VEHICLE_PROPERTY_UPDATE,
  REQUEST_VEHICLE,
  REQUEST_VEHICLE_TASKS,
} from '../../../constants';
import { VBox, HBox } from '../../../../../components/Box';
import { VehicleInfoCard } from '../../../components/CardInfo';
import { VehicleDataCard } from '../../../components/CardData';
import { VehicleFinanceSalesCard } from '../../../components/CardFinanceSales';
import { VehicleCardCounters } from '../../../components/CardCounters';
import { VehicleFinancePurchaseCard } from '../../../components/CardFinancePurchase';
import { VehicleDocumentsCard } from '../../../components/CardDocuments';
import { VehicleLocationCard } from '../../../components/VehicleLocationCard';
import { Card } from '../../../../../components/Card';
import { Button } from '../../../../../components/Buttons';
import { VehicleBpmCard } from '../../../components/CardBPM';
import { Slider } from '../../../components/Slider';
import { VehicleDataConsumptionCard } from '../../../components/ConsumptionEnviromentData';
import { VehicleRDWandHistoryDataCard } from '../../../components/RDWandHistoryCard';
import { VehicleLabelCard } from '../../../components/CardLabel';
import { VehicleTransportCard } from '../../../components/CardTransport';
//import { VehicleHooicardtakeout } from '../components/cardHooicardtakeout';
import { VehicleProductTasksSection } from '../../../components/VehicleProductTasksSection';

import { VehicleExtraCostCard } from '../../../components/CardExtraCost';
import { Check, IsOpen } from '../../../../../components/Icon';
import { VehicleOutgoingInvoiceCard } from '../../../components/CardOutgoingInvoice';
import {
  deleteVehicle,
  deleteVehicleProperty,
  downloadImages,
  fetchVehicle,
  fetchVehicleTasks,
  setVehicleProperty,
} from '../../../actions';
import { VehicleWebsiteCard } from '../../../components/CardWebsite';
import { VehicleInspectionCard } from '../../../components/VehicleInspectionCard';

import { Loader } from '../../../../../components/Loader';
import { VehicleTasksCard } from '../../../components/CardVehicleTasks';
import { VehicleInvoicesCard } from '../../../components/VehcleInvoicesCard';
import { fetchVehicleInvoices } from '../../../../Invoices/actions';
import { REQUEST_VEHICLE_INVOICES } from '../../../../Invoices/constants';
//import { VehicleHooiInstallationPhotoCard } from '../components/CardHooiInstallationPhotos';
import { VehicleRemarksCard } from '../../../components/CardVehicleRemarks';
import env from '../../../../../env';
import { VehicleClaimCard } from '../../../components/CardClaim';
import { Permission } from '../../../../../components/Permission';
import {
  VEHICLE_REMOVE,
  VEHICLE_EDIT,
  VEHICLE_INVOICES_BUTTON,
  VEHICLE_DETAILS_BUTTON,
  VEHICLE_DOWNLOAD_IMAGES,
  VEHICLE_ACTIONS_BUTTON,
  VEHICLE_HEXON_BUTTON,
  VEHICLE_TAKEN_BUTTON,
  VEHICLE_LOGS,
  VEHICLE_EXTRA_COSTS_CRUD,
  VEHICLE_TRANSPORT_CRUD,
  VEHICLE_INSPECTION_CRUD,
  VEHICLE_DOCUMENTS_CRUD,
  PURCHASING_DATA_CRUD,
  SALES_DATA_CRUD,
  INVOICES_PAGE,
  DEP_FINANCE,
  DEP_COMMERCE,
  DEP_WALSTREET,
  DEP_ADMINISTRATION,
  DEP_IT,
  DEP_WORKSHOP,
  DEP_ADMIN,
  DEP_TRANSPORT,
} from '../../../../../components/Permission/constants';
import { VehicleOptionsCard } from '../../../components/VehicleOptionsCard';
import { AppClientId } from '../../../../Shared/constants';
import { SaleAgreementPdfPreview } from '../../../components/SaleAgreement/SaleAgreementPdfPreview';
import { EditVehicleOptions } from '../../../pages/create/OptionsStep/EditVehicleOptions';
import { PdfPreview } from '../../../components/PriceCardPDF/PdfPreview';
import cn from 'classnames';
import styles from './detailsColumns.module.css';
import LoadingDetailsPageCard from '../../../../../containers/App/Components/LoadingDetailsPageCard/LoadingDetailsPageCard';
import { NewAndNotUsed } from '../../../components/NewAndNotUsedPDF/NewAndNotUsed';
import { VehicleRecommendationCard } from '../../../components/RecommendationCard';
import { DebitorVehicleCard } from '../../../components/DebitorVehicleCard';
import { VehicleInspectionCardv2 } from '../../../components/VehicleInspectionCardv2';
import { VehicleHooicardproducts } from '../../../components/cardHooicardproducts';
import { HILT_check_in } from '../../../../KanbanBoards/cells/HILT/HILT_check_in';
import { VehicleHooicardInslag } from '../../../components/cardHooicardinslag';
import { VehicleTasksRemarksCard } from '../../../components/CardVehicleTasksRemarks';
import { selectActions } from '../../../../Actions/selectors';
import { initialState as api } from '../../../../Api/reducer';
import { VehicleWorkflowManagementCard } from '../../../components/CardWorkflowManagement';
import { VehicleCarcollectCard } from '../../../components/CardCarcollect';

//comment1
const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 100%;
  }
  .info-card {
    min-width: 260px;
    width: 100%;
    margin: 5px 0;
    // border: 1px solid #dbdcdc;
    // box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.07); /* Grey box shadow */
  }
  .info-card.wide {
    width: 99%;
  }

  .info-card-fin {
    min-width: 260px;
    width: 100%;
    margin: 5px 0;
    // border: 1px solid #dbdcdc;
    // box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.07); /* Grey box shadow */
  }
  .info-card-fin.wide {
    width: 99%;
  }

  .vehicle-info-card info-card {
    &.misc {
      .button {
        margin: 2px;
        background-color: #ddd;
        color: #333;
      }
    }
  }

  .vbox .toggleBtn {
    margin-left: auto;
    width: 12%;
  }

  .slider-block {
    background-color: #fff;
    min-width: 260px;
    width: 100%;
    margin: 5px 0;
    border: 0px solid #dbdcdc;
    box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.07);
  }

  .vbox.col {
    width: auto;

    @media (max-width: 768px) {
      width: 100%;
    }
  }
`;

const Wrapper = styled.div`
  // display: flex;
  // flex-direction: row;
  // justify-content: space-between;
  display: grid;
  grid-template-columns: 49% 49%;
  gap: 10px;
  width: 100%;

  @media (max-width: 1440px) {
    gap: 5px;
    width: 100%;
  }

  @media (max-width: 768px) {
    display: grid;
    flex-direction: column;
    justify-content: center;

    & > div {
      width: 100%;
    }
  }
`;
const STATE = {
  previewType: 'exterior',
  isShowExsterior: true,
  isShow: true,
  loading: false,
  IsOpen: false,
  showSaleAgreementPdfPreview: false,
};

class VehicleDetailsColumnsComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  get vehicle() {
    return this.props.vehicle;
  }

  componentDidMount() {
    this.timeout(() => this.setState({ showOutgoingInvoiceCard: true }), 1500);
    this.timeout(() => this.setState({ loadSliderAfterTimeout: true }), 800);
    this.timeout(this.props.fetchVehicleTasks, 2000);
    this.setOutgoingProductInvoiceCardData();
  }

  renderActionModal() {
    return (
      <HILT_check_in
        vehicleDetails
        cell={{ vehicle: this.props.vehicle }}
        action={{ label: 'label', id: this.getActionIdByName('HOOI_check_in') }}
        payload={{ task_name: 'task_spray' }}
        column={{ label: 'HOOI_check_in' }}
        loggedUserId={this.props.loggedInUser}
      />
    );
  }

  getActionIdByName(name) {
    return this.props.actions?.find(a => a.functionName === name)?.id ?? null;
  }

  setOutgoingProductInvoiceCardData() {
    this.props.fetchVehicleInvoices(result => {
      if (result?.items?.length > 0) {
        const outgoingProductInvoices = result.items.filter(invoice => {
          const isOutgoing = invoice?.direction === 'outgoing';
          const isProduct = invoice?.subjectType === 'product';
          const isNotFinal = !invoice?.isFinal;

          return isOutgoing && isProduct && isNotFinal;
        });

        let lastFinalProductInvoice = [];

        if (!outgoingProductInvoices?.length) {
          lastFinalProductInvoice = result.items.filter(invoice => {
            const isOutgoing = invoice?.direction === 'outgoing';
            const isProduct = invoice?.subjectType === 'product';
            const isFinal = invoice?.isFinal === true;

            return isOutgoing && isProduct && isFinal;
          });
        }

        console.log('Filtered outgoing product invoices:', lastFinalProductInvoice);

        if (outgoingProductInvoices.length > 0 || lastFinalProductInvoice?.length > 0) {
          const lastCreatedOutgoingProductId = outgoingProductInvoices[0]?.id ?? lastFinalProductInvoice[0]?.id;
          this.setState({ outgoingProductInvoiceId: lastCreatedOutgoingProductId });
        }
      }
    });
  }

  hideBlock(val) {
    this.setState({ loading: true });
    return this.setState(prev => ({ ...prev, previewType: 'exterior', isShow: val, loading: false }));
  }

  setShowLocationChange = () => {
    this.setState({ showLocationChange: true });
  };

  hideExteriorBlock(val) {
    this.setState({ loading: true });
    return this.setState(prev => ({ ...prev, isShowExsterior: val, loading: false }));
  }

  handleDelete = () => {
    // eslint-disable-next-line no-alert, no-restricted-globals
    if (!confirm('delete vehicle?')) return;
    this.props.deleteVehicle(result => {
      if (result) {
        console.log(result, 'RES');
        return this.to('/');
      }
    });
  };

  downloadImages() {
    this.setState({ downloadingImages: true }, () => {
      this.props.downloadImages(result => {
        this.setState({ downloadingImages: false });
        window.open('/storage/zip/tmp/' + this.props.vehicle.id + '.zip');
      });
    });
  }

  renderThirdColumn() {
    const vehicle = this.props.vehicle;
    return (
      <>
        <VehicleDocumentsCard vehicle={this.props.vehicle} />

        <VehicleLocationCard vehicle={this.props.vehicle} vehicle_details />

        <Card className={cn('vehicle-info-card info-card misc', styles.card)}>
          <h2 className="card-title mb-2 text-muted">other</h2>
          <Permission permission={VEHICLE_EDIT}>
            <div className={styles.containerButton}>
              <Button className={styles.buttonEdit} primary onClick={this.tofn(`/vehicles/${this.vehicle.id}/edit`)}>
                {this.lbl('edit')}
              </Button>
            </div>
          </Permission>
          {/* <Button onClick={this.tofn(`/vehicles/${this.vehicle.id}`)}>{this.lbl('vehicle.details.columns.title')}</Button> */}

          {window.innerWidth > 768 && (
            <>
              <Button onClick={this.tofn(`/vehicles/${this.vehicle.id}/carcollect`)}>Carcollect</Button>

              <a
                className="button text-center text-decoration-none text-white"
                href={`${api.rootUrl}pdf/${this.vehicle.id}?template=schaderapport`}
                target="_blank"
              >
                Inspectie rapport
              </a>

              <a
                className="button text-center text-decoration-none text-white"
                href={`${api.rootUrl}pdf/${this.vehicle.id}?template=afleverrapport`}
                target="_blank"
              >
                Inzet rapport
              </a>
              {/* <Button onClick={this.tofn(`/vehicles/${this.vehicle.id}`)}>{this.lbl('vehicle.details.columns.title')}</Button> */}

              <Permission permission={VEHICLE_DETAILS_BUTTON}>
                <div className={styles.containerButton}>
                  <Button className={styles.button} onClick={this.tofn(`/vehicles/${this.vehicle.id}/legacy`)}>
                    {this.lbl('vehicle.details.title')}
                  </Button>
                </div>
              </Permission>
              {/* <Button onClick={this.tofn(`/vehicles/${this.vehicle.id}/options`)}>
             {this.lbl('vehicle.details.options.title')}
             </Button> */}
              {/* <Button onClick={this.tofn(`/vehicles/${this.vehicle.id}/documents`)}>
             {this.lbl('vehicle.details.documents.title')}
             </Button>
             <Button onClick={this.tofn(`/vehicles/${this.vehicle.id}/price`)}>
             {this.lbl('vehicle.details.price.title')}
             </Button>
             <Button onClick={this.tofn(`/vehicles/${this.vehicle.id}/supplier`)}>
             {this.lbl('vehicle.details.supplier.title')}
             </Button> */}

              {/* <Permission permission={DEP_IT}>
                <Button onClick={this.tofn(`/vehicles/${this.vehicle.id}/actions`)}>actions</Button>
              </Permission> */}
              {/*
             <Permission permission={VEHICLE_TAKEN_BUTTON}>
                <Button onClick={this.tofn(`/vehicles/${this.vehicle.id}/state`)}>Taken</Button>
             </Permission>
             */}
              <Permission permission={VEHICLE_HEXON_BUTTON}>
                <div className={styles.containerButton}>
                  <Button className={styles.button} onClick={this.tofn(`/vehicles/${this.vehicle.id}/hexon`)}>
                    Hexon
                  </Button>
                </div>
              </Permission>
              {/* <Permission permission={DEP_IT}>
                <div className={styles.containerButton}>
                  <div className={styles.containerButton}></div>
                  <Button
                    className={styles.button}
                    onClick={() => window.open(`/vehicles/${this.vehicle.id}/silverdat`, '_blank')}
                  >
                    Silverdat
                  </Button>
                </div>
              </Permission> */}
            </>
          )}
          {/* <Permission permission={VEHICLE_DOWNLOAD_IMAGES}>
            <div className={styles.containerButton}>
              <Button
                className={styles.button}
                disabled={this.state.downloadingImages}
                onClick={this.downloadImages.bind(this)}
              >
                {this.state.downloadingImages ? <Loader small /> : null} {this.lbl('vehicle.download-images')}
              </Button>
            </div>
          </Permission> */}
          <Permission permission={VEHICLE_LOGS}>
            <div className={styles.containerButton}>
              <Button className={styles.button} onClick={this.tofn(`/vehicles/${this.vehicle.id}/history`)}>
                Logs
              </Button>
            </div>
          </Permission>
          {/* {env.enable_hemex ? <Button onClick={this.tofn(`/vehicles/${this.vehicle.id}/hemex`)}>Hemex</Button> : null} */}
          {env.clientId === AppClientId.INDEWAL ? (
            <Permission permission={DEP_IT}>
              <>
                <div className={styles.containerButton}>
                  <Button
                    className={styles.button}
                    active={this.vehicle.special_customer}
                    onClick={() => {
                      this.props.setVehicleProperty('special_customer', this.vehicle.special_customer == '1' ? null : '1');
                    }}
                  >
                    {this.vehicle.special_customer ? <Check /> : null}&nbsp;Special customer
                  </Button>
                </div>
              </>
            </Permission>
          ) : null}

          <Permission permission={VEHICLE_REMOVE}>
            <div className={styles.containerButton}>
              <Button className={styles.buttonDelete} warning onClick={this.handleDelete}>
                Delete
              </Button>
            </div>
          </Permission>
        </Card>
      </>
    );
  }

  render() {
    const vehicle = this.props.vehicle;
    const params = new URLSearchParams(window.location.search);
    const showLinktree = params.get('showLinkTree') === 'yes' || window.innerWidth <= 768;

    return (
      <Container className={styles.containerPage}>
        <VBox left className={cn('col', styles.firstColumn)} top>
          {showLinktree && (
            <Card className={cn('vehicle-info-card info-card misc', styles.card)}>
              <h2 className="card-title mb-2 text-muted">{this.lbl('vehicle.linktree.quick_links')}</h2>
              <Permission permission={VEHICLE_EDIT}>
                <div className={styles.containerButton}>
                  {vehicle.location_address_id == '5' ? (
                    <div className={styles.containerButton}>
                      {this.lbl('vehicle.linktree.presentlocation')} {this.lbl('vehicle.linktree.grote_loods')}
                    </div>
                  ) : vehicle.location_address_id == '4' ? (
                    <div className={styles.containerButton}>
                      {this.lbl('vehicle.linktree.presentlocation')} {this.lbl('vehicle.linktree.kleine_loods')}
                    </div>
                  ) : vehicle.location_address_id == '6' ? (
                    <div className={styles.containerButton}>
                      {this.lbl('vehicle.linktree.presentlocation')} {this.lbl('vehicle.linktree.Parkeergarage')}
                    </div>
                  ) : (
                    'Niet aanwezig'
                  )}
                  <Button className={styles.button} onClick={this.setShowLocationChange}>
                    {this.lbl('vehicle.location.change')}
                  </Button>
                  {this.state.showLocationChange && (
                    <VehicleLocationCard
                      vehicle={this.props.vehicle}
                      showLocationChange={this.state.showLocationChange}
                      setShowLocationChange={value => this.setState({ showLocationChange: value })}
                    />
                  )}
                </div>

                <div className={styles.containerButton}>
                  <Button className={styles.button} onClick={this.tofn(`/boards/1/action-page/${vehicle.id}`)}>
                    {this.lbl('vehicle.linktree.inspecteren')}
                  </Button>
                </div>
                {this.renderActionModal()}

                {/* <div className={styles.containerButton}>
                    <Button
                      className={styles.button}
                      onClick={() => {

                        this.setState(
                          prevState => ({ showInslagModal: !prevState.showInslagModal }),

                        );
                      }}>
                      {this.lbl('vehicle.location.inslag')}
                    </Button>

                    </div> */}
              </Permission>
            </Card>
          )}
          <VehicleInfoCard vehicle={this.props.vehicle} />
          <VehicleDataCard vehicle={this.props.vehicle} />
          {window.innerWidth > 768 && (
            <>
              <VehicleDataConsumptionCard vehicle={this.props.vehicle} />
              <VehicleRDWandHistoryDataCard vehicle={this.props.vehicle} />
            </>
          )}

          {window.innerWidth <= 768 && (
            <>
              <VehicleHooicardInslag
                vehicle={this.props.vehicle}
                vehicleId={this.props.vehicle?.id}
                loggedUserId={this.props.loggedInUserId}
                hooiInslagUserId={this.props.hooiInslagUserId}
                showModal={this.state.showInslagModal} // Modal state
                onCloseModal={() => this.setState({ showInslagModal: false })} // Close modal handler
                onResetParentState={() => this.setState({ showInslagModal: false })} // Reset parent state
              />
              {this.props.workTask ? (
                <LoadingDetailsPageCard />
              ) : (
                <VehicleTasksCard vehicle={this.props.vehicle} onAdded={this.setOutgoingProductInvoiceCardData.bind(this)} />
              )}
              <VehicleTasksRemarksCard vehicle={this.props.vehicle} />
              {this.props.workRemarks ? (
                <Loader small />
              ) : (
                <VehicleRemarksCard vehicle={this.props.vehicle} loggedUserId={this.props.loggedInUserId} />
              )}
              <Permission
                permission={[DEP_FINANCE, DEP_COMMERCE, DEP_ADMINISTRATION, DEP_ADMIN, DEP_IT, DEP_WORKSHOP, DEP_WALSTREET]}
              >
                <Card className={cn('vehicle-info-card info-card data wide', styles.card)} style={{ width: '100%' }}>
                  <EditVehicleOptions photoBlock vehicle={this.props.vehicle} />
                </Card>
              </Permission>
              <Permission
                permission={[DEP_FINANCE, DEP_COMMERCE, DEP_ADMINISTRATION, DEP_ADMIN, DEP_IT, DEP_WORKSHOP, DEP_WALSTREET]}
              >
                <VehicleOptionsCard vehicle={this.props.vehicle} />
              </Permission>
              <Permission permission={VEHICLE_INSPECTION_CRUD}>
                <VehicleInspectionCardv2 vehicle={this.props.vehicle} />
              </Permission>

              <Permission permission={[DEP_COMMERCE, DEP_ADMINISTRATION, DEP_ADMIN, DEP_IT]}>
                <VehicleDataConsumptionCard vehicle={this.props.vehicle} />
              </Permission>
            </>
          )}
          {window.innerWidth > 768 && window.innerWidth < 1400 && this.renderThirdColumn(this.props.vehicle)}
        </VBox>
        <VBox left className="col" top>
          {window.innerWidth > 768 && (
            <>
              <Wrapper>
                <VBox top>
                  {this.props.workTask ? (
                    <LoadingDetailsPageCard />
                  ) : (
                    <VehicleTasksCard
                      vehicle={this.props.vehicle}
                      onAdded={this.setOutgoingProductInvoiceCardData.bind(this)}
                    />
                  )}

                  {/* {this.props.workTask ? (
                    <LoadingDetailsPageCard />
                  ) : (
                    !env.hide_task_card && (
                      <VehicleTasksCard
                        vehicle={this.props.vehicle}
                        onAdded={this.setOutgoingProductInvoiceCardData.bind(this)}
                      />
                    )
                  )} */}
                  {/* <VehicleProductTasksSection
                    vehicleId={this.props.vehicle?.id}
                    onAdded={this.setOutgoingProductInvoiceCardData.bind(this)}
                    isHiltermann={true}
                  />  */}

                  {this.props.workRemarks ? (
                    <Loader small />
                  ) : (
                    <VehicleRemarksCard vehicle={this.props.vehicle} loggedUserId={this.props.loggedInUserId} />
                  )}
                </VBox>

                <VBox top>
                  {this.props.workVehicle ? (
                    <LoadingDetailsPageCard />
                  ) : (
                    <VehicleFinanceSalesCard vehicle={this.props.vehicle} />
                  )}
                  <VehicleWorkflowManagementCard vehicle={this.props.vehicle} />
                  <VehicleCarcollectCard vehicle={this.props.vehicle} />
                </VBox>
               
              </Wrapper>

              <Card className={cn('vehicle-info-card info-card data wide', styles.card)} style={{ width: '100%' }}>
                <EditVehicleOptions photoBlock vehicle={this.props.vehicle} />
              </Card>

              <VehicleOptionsCard vehicle={this.props.vehicle} />

              <Permission permission={VEHICLE_INSPECTION_CRUD}>
                <VehicleInspectionCardv2 vehicle={this.props.vehicle} />
              </Permission>
            </>
          )}
        </VBox>

        {window.innerWidth > 1400 && (
          <VBox left className={cn('col align-items-end', styles.thirdColumn)} top>
            {this.renderThirdColumn(this.props.vehicle)}
          </VBox>
        )}

        {window.innerWidth < 748 && (
          <VBox left className={cn('col align-items-end', styles.thirdColumn)} top>
            {this.renderThirdColumn(this.props.vehicle)}
          </VBox>
        )}
      </Container>
    );
  }
}

VehicleDetailsColumnsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    //  work: selectWorks([REQUEST_VEHICLE_INVOICES]),
    actions: selectActions(),
    workVehicle: selectWork(REQUEST_VEHICLE),
    workRemarks: selectWork(`${REQUEST_VEHICLE_PROPERTY_UPDATE}-remarks`),
    workTaskRemarks: selectWork(`${REQUEST_VEHICLE_PROPERTY_UPDATE}-taskRemarks`),
    loggedInUserId: selectUserId(),
    workTask: selectWork(REQUEST_VEHICLE_TASKS),
    //creditorCompany: selectCompany(getPropByName(ownProps.vehicle, 'creditor_company')),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setVehicleProperty(name, value, callback) {
      if (value === null || value === undefined) {
        dispatch(deleteVehicleProperty(ownProps.vehicle.id, name));
      } else {
        dispatch(setVehicleProperty(ownProps.vehicle.id, name, value));
      }
    },
    deleteVehicle(callback) {
      dispatch(deleteVehicle(ownProps.vehicle.id, callback));
    },
    downloadImages(callback) {
      dispatch(downloadImages(ownProps.vehicle.id, callback));
    },
    fetchVehicleInvoices() {
      dispatch(fetchVehicleInvoices(ownProps.vehicle?.id));
    },
    print() {
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'label_printer_queue', '1'));
    },
    fetchVehicleTasks(callback) {
      dispatch(fetchVehicleTasks(ownProps.vehicle?.id, callback));
    },
    setValueLocationAddress(val) {
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'location_address_id', val));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'location_company_id', '4'));
      // window.location.reload();
    },
    setValueTransportOutgoing() {
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'transport_outgoing_initiated', '0'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'transport_outgoing_done', '1'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'transport_outgoing_assigned_to', null));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'transport_outgoing_completed_date', 'date_today'));
      // window.location.reload();
    },
    setValuePopnagels() {
      let extra_cost_popnagels_sum = Number(ownProps.vehicle?.extra_cost_popnagels) + 15;
      let extra_cost_sum = Number(ownProps.vehicle?.extra_cost_sum) + 15;
      let extra_cost_economic_prize_sum = Number(ownProps.vehicle?.economic_prize) + 15;

      dispatch(setVehicleProperty(ownProps.vehicle.id, 'task_popnagels', '1'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'extra_cost_popnagels', extra_cost_popnagels_sum));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'extra_cost_sum', extra_cost_sum));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'economic_prize', extra_cost_economic_prize_sum));
    },
    setValueTestDriveAllClear(val) {
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'state_engine_general', '1'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'state_ac', '1'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'state_brakes', '1'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'state_transmission', '1'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'state_electrics', '1'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'state_drive', '1'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'task_test_drive', '0'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'task_test_drive_done', '1'));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleDetailsColumns = compose(withConnect, withRouter)(VehicleDetailsColumnsComp);
